import React from 'react';

function App() {
  return (
    <div className="App">
      Site pessoal por ser iniciado!
    </div>
  );
}

export default App;
